/**
 * @flow
 * @relayHash 7c170cae41d70417ea00acfe19538d70
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type profile_viewer$ref = any;
export type profile_QueryVariables = {| |};
export type profile_QueryResponse = {|
  +viewer: ?{|
    +id: string,
    +$fragmentRefs: profile_viewer$ref,
  |},
|};
*/


/*
query profile_Query {
  viewer {
    id
    ...profile_viewer
  }
}

fragment profile_viewer on Viewer {
  id
  profile {
    id
    user_id
    email
    external_provider
    first_name
    is_new_user
    ga_account_goal_sent
    last_name
    picture
    company_name
    company_size {
      name
      id
    }
    industry {
      name
      id
    }
    job_type {
      name
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
  v0
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "profile_Query",
  "id": null,
  "text": "query profile_Query {\n  viewer {\n    id\n    ...profile_viewer\n  }\n}\n\nfragment profile_viewer on Viewer {\n  id\n  profile {\n    id\n    user_id\n    email\n    external_provider\n    first_name\n    is_new_user\n    ga_account_goal_sent\n    last_name\n    picture\n    company_name\n    company_size {\n      name\n      id\n    }\n    industry {\n      name\n      id\n    }\n    job_type {\n      name\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "profile_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v0,
          {
            "kind": "FragmentSpread",
            "name": "profile_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "profile_Query",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v0,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "profile",
            "storageKey": null,
            "args": null,
            "concreteType": "Profile",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "ga_account_goal_sent",
                "args": null,
                "storageKey": null
              },
              v0,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "email",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "external_provider",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "first_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "is_new_user",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "user_id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "last_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "picture",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "company_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "company_size",
                "storageKey": null,
                "args": null,
                "concreteType": "CompanySize",
                "plural": false,
                "selections": v1
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "industry",
                "storageKey": null,
                "args": null,
                "concreteType": "Industry",
                "plural": false,
                "selections": v1
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "job_type",
                "storageKey": null,
                "args": null,
                "concreteType": "JobType",
                "plural": false,
                "selections": v1
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = 'bd9b692fffd4cf29b6a035e04eaa181e';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/profile_Query.graphql.js